var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", [
        _c("p", { staticClass: "result-panel-text" }, [
          _vm._v(_vm._s(_vm.caption))
        ]),
        _vm._v(" "),
        _vm.isFetching
          ? _c("div", [_c("AxSpinner", { attrs: { show: true } })], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.showFetchError && _vm.lastFetchError !== "no result"
          ? _c("div", [
              _c("p", { staticClass: "result-panel-text" }, [
                _vm._v(
                  "\n      System error, please refresh the page and try again\n    "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showFetchError && _vm.lastFetchError === "no result"
          ? _c("div", [
              _c("p", { staticClass: "result-panel-text" }, [
                _vm._v(
                  "Please try searching in the Menu tab or update your search and try again"
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isFetching && !_vm.showFetchError
          ? _c(
              "ul",
              { staticClass: "ax-results-panel__group" },
              _vm._l(_vm.items, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "ax-results-panel__item",
                    class: _vm.itemClassForIndex(index)
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "ax-results-panel__item-link",
                        class: item.additionalClasses,
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.navigateAction($event, item)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ax-results-panel__item-label" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ax-icon-chip result-panel-chip",
                                attrs: { id: "chip", tabindex: "0" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ax-icon-chip__icon",
                                    style: _vm.iconColorForResult(item)
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.entityType) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "ax-icon-chip__label result-panel-chip__label",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.itemLabelHtml(item))
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "ax-icon-chip__sublabel result-panel-chip__sublabel",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.itemSublabelHtml(item)
                                    )
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "ax-results-panel__item-target" },
                          [
                            item.target === "_blank"
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "ax-results-panel__item-target-link popout",
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.navigateActionBlank(
                                          $event,
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "ax-icon--pop-out" })]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }